module.exports = __webpack_public_path__ + "img/block2-2.96769d56.jpg";